import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

const adminAPI = API('/api/myAdmins.v1/', { type: 'rest' });

export const getMyAdmins = (partnerId?: string | null, fields: Array<string> = ['courses', 's12ns', 'partners']) => {
  const uri = new URI().addQueryParam('fields', fields.join(','));
  if (partnerId) {
    uri.addQueryParam('q', 'byPartner').addQueryParam('partnerId', partnerId);
  }
  return Q(adminAPI.get(uri.toString()));
};
